// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"2512ad80","224":"b7024135","441":"2512ad80","654":"2512ad80","833":"2512ad80"}[chunkId] + ".chunk.css";
};